import React, { useState } from 'react';
import { formatPhoneUsDisplay } from '../add/formatPhoneUsDisplay';
import { formatDisplayDateTime } from './format';

// Translated at module load so __() sees a string literal (see RequestBlock).
const TYPE_LABELS = {
    rating: __('1thru5'),
    testimonial: __('Testimonial'),
};
const MISSING_VALUE = '–';

export default function SentRequestsTable({ requests, timezone }) {
    const [expandedIds, setExpandedIds] = useState(() => new Set());

    // The button lets touch devices expand the full message; the title attribute still gives mouse users a hover tooltip.
    const toggleExpanded = (id) => {
        setExpandedIds((previous) => {
            const next = new Set(previous);
            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }
            return next;
        });
    };

    return (
        <div className="table-responsive">
            <table className="table table-sm demo-sent-requests-table">
                <thead>
                    <tr>
                        <th scope="col">{__('Type')}</th>
                        <th scope="col">{__('Name')}</th>
                        <th scope="col">{__('Phone')}</th>
                        <th scope="col">{__('Sent')}</th>
                        <th scope="col">{__('Message')}</th>
                    </tr>
                </thead>
                <tbody>
                    {requests.map((request) => {
                        const expanded = expandedIds.has(request.id);

                        return (
                            <tr key={request.id}>
                                <td>{TYPE_LABELS[request.request_type] || request.request_type}</td>
                                <td>{request.first_name || MISSING_VALUE}</td>
                                <td>{request.phone ? formatPhoneUsDisplay(request.phone) : MISSING_VALUE}</td>
                                <td>{formatDisplayDateTime(request.sent_at, timezone)}</td>
                                <td className="demo-sent-requests-message">
                                    {request.message
                                        ? (
                                            <button
                                                type="button"
                                                className={`demo-sent-requests-message-text${expanded ? ' is-expanded' : ''}`}
                                                title={request.message}
                                                aria-expanded={expanded}
                                                onClick={() => toggleExpanded(request.id)}
                                            >
                                                {request.message}
                                            </button>
                                        )
                                        : MISSING_VALUE}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
